(function () {
    const navBarMobileButton = document.querySelector("#btn-mobile");
    const mainNav = document.querySelector("#main-nav");

    const closeNav = () => {
        mainNav?.classList.remove("open");
    };

    const updateNav = () => {
        mainNav?.classList.remove("transition");
        closeNav();
    };

    navBarMobileButton?.addEventListener("click", (event) => {
        mainNav?.classList.add("transition");
        mainNav?.classList.toggle("open");
    });

    window.addEventListener("resize", updateNav);
    window.addEventListener("scroll", closeNav);
})();
